import { render } from "./FourthTab.vue?vue&type=template&id=d803b234&scoped=true"
import script from "./FourthTab.vue?vue&type=script&lang=js"
export * from "./FourthTab.vue?vue&type=script&lang=js"

import "./FourthTab.vue?vue&type=style&index=0&id=d803b234&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d803b234"]])

export default __exports__